export type LegalTextPart =
  | string
  | { bold: string }
  | { link: string; href: string; external?: boolean };

export interface LegalListItem {
  parts: LegalTextPart[];
  children?: LegalListItem[];
}

export type LegalBlock =
  | { type: "p"; parts: LegalTextPart[] }
  | { type: "ul"; items: LegalListItem[] };

export interface LegalSection {
  title: string;
  blocks: LegalBlock[];
}

export function legalItem(parts: LegalTextPart[], children?: LegalListItem[]): LegalListItem {
  return children ? { parts, children } : { parts };
}

export function legalP(...parts: LegalTextPart[]): LegalBlock {
  return { type: "p", parts };
}

export function legalUl(...items: LegalListItem[]): LegalBlock {
  return { type: "ul", items };
}

export function legalBold(label: string): LegalTextPart {
  return { bold: label };
}
